const customGift = (state = "", action) => {
    switch(action.type) {
        case 'customGift':
            return action.payload;
        default:
            return state;
    }
}

export default customGift;